export type IObserver = () => void;

export default class KwObserver<S extends string> {
  observerMap: {[state in S]?: IObserver[]} = {};
  oneTimeObserverMap: {[state in S]?: IObserver[]} = {};

  addObserver(state: S, observer: IObserver) {
    if (!this.observerMap[state]) {
      this.observerMap[state] = [];
    }
    this.observerMap[state]?.push(observer);
  }
  addOneTimeObserver(state: S, observer: IObserver) {
    this.addObserver(state, observer);
    if (!this.oneTimeObserverMap[state]) {
      this.oneTimeObserverMap[state] = [];
    }
    this.oneTimeObserverMap[state]?.push(observer);
  }
  removeObserver(state: S, observer: IObserver) {
    this.observerMap[state] = this.observerMap[state]?.filter(
      item => item !== observer
    );
  }
  notify(state: S) {
    const observers = this.observerMap[state] ?? [];
    for (const ob of observers) {
      ob();
    }
    const oneTimes = this.oneTimeObserverMap[state];
    if (oneTimes) {
      oneTimes.forEach(ob => this.removeObserver(state, ob));
      if (oneTimes.length) this.oneTimeObserverMap[state] = [];
    }
  }
}
